<template>
    <div>
        <div class="screen_media bg_eef1fa pa_top_10">
            <div class="main bg_fff">
                <div class="login">
                    <h2>登录</h2>
                    <form method="post" onsubmit="return false;">
                        <div class="login_input flex_start">
                            <img src="@/assets/images/account.png"/>
                            <input type="text" name="username" v-model="username" placeholder="请输入用户名" />
                        </div>
                        <div class="login_input flex_start">
                            <img src="@/assets/images/password.png"/>
                            <input type="password" name="password" v-model="password" placeholder="请输入密码" />
                        </div>
                        <button type="submit" @click="loginBtn">立即登录</button>
                        <p><router-link to="./register">立即注册</router-link></p>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "login",
        data () {
            return {
                id: 0,
                detail:[],
                username: '',
                password: ''
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {
            loginBtn: function () {
                let _this = this,
                    username = _this.username,
                    password = _this.password;
                if(username == '' || password == '')
                {
                    layer.msg('请填入账号密码');
                    return false;
                }
                this.$http({
                    url: 'user/login',
                    method: 'post',
                    headers: {"Content-Type": "multipart/form-data"},
                    data:{account:username,password:password}
                }).then(res => {
                    if(res.data.code == 1) {
                        localStorage.setItem('user_id',res.data.data.userinfo.id);
                        localStorage.setItem('user_username',res.data.data.userinfo.username);
                        localStorage.setItem('user_nickname',res.data.data.userinfo.nickname);
                        localStorage.setItem('user_avatar',res.data.data.userinfo.avatar);
                        localStorage.setItem('user_token',res.data.data.userinfo.token);
                        setTimeout(function () {
                            window.location.href = '/my/index';
                            /*_this.$router.push({
                                path: '/my/index'
                            })*/
                        },1000);
                    }
                    layer.msg(res.data.msg);
                });
            }
        }
    }
</script>

<style scoped>
    .pa_top_10{padding-top:10px;}
    .screen_media{width: 100%;padding-bottom: 45px;}
    .login{width:402px;text-align: center;display: block;margin:0 auto;padding:70px 0 100px;}
    .login h2{width: 100%;font-size: 36px;line-height: 36px;color:#000;font-weight: normal;display: block;}
    .login_input,.login button{width:402px;height: 60px;display: block;margin-top:20px;}
    .login_input {border:1px solid #dcdcdc;line-height: 58px;font-size:14px;}
    .login_input img{width: 20px;height: 22px;object-fit: contain;display: block;margin:18px 15px 18px 20px;}
    .login_input input{height: 58px;line-height: 58px;border:none;width: calc(100% - 55px);display: block;}
    .login button{background: #5e8dee;color:#fff;text-align: center;font-size:20px;line-height: 60px;display: block;border:none;}
    .login p{width: 100%;display: block;text-align: right;font-size:14px;line-height: 20px;color:#666;}
    .login p a{color:#5e8dee;display: inline-block;margin-top:10px;}

    @media screen and (max-width: 1240px) {
        .login{width: 100%;max-width: 402px;padding:5.645vw 0 8.0645vw;}
        .login_input,.login button{width:100%;}
    }
    @media screen and (max-width: 440px) {
        .login_input,.login button,.login p{width:96%;margin-left:2%;}
    }
</style>



// WEBPACK FOOTER //
// src/pages/my/login.vue